export function login(sessionId, isAdmin, myPage, tag, permissions) {
  localStorage.setItem("atsSessionId", sessionId);
  localStorage.setItem("atsIsAdmin", isAdmin);
  localStorage.setItem("atsMyPage", myPage);
  localStorage.setItem("atsTag", tag);
  localStorage.setItem("atsPermissions", permissions);

  window.location.replace(`${process.env.PUBLIC_URL}`);
}

export function logout() {
  localStorage.removeItem("atsSessionId");
  localStorage.removeItem("atsIsAdmin");
  localStorage.removeItem("atsMyPage");
  localStorage.removeItem("atsTag");
  localStorage.removeItem("atsPermissions");

  window.location.replace(`${process.env.PUBLIC_URL}`);
}

export function isAuthenticated() {
  return localStorage.getItem("atsSessionId") !== null;
}

export function hasPermission(permission) {
  const permissions = localStorage.getItem("atsPermissions") ?? "";
  return permissions.includes(permission) || permissions.includes("Admin");
}
